exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.actions-container[data-v-f1cf9902] {\n  padding: 0.3em;\n  text-align: right;\n}\n\n", ""]);

// exports
